// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"631":"0c37b0b7","773":"428027cc"}[chunkId] + ".chunk.css";
};